import { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import { toast } from 'sonner';

interface usePDFGeneratorReturn {
  isGenerating: boolean;
  generateAndDownloadPDF: (pdfComponent: React.ReactElement, fileName: string) => Promise<void>;
}

export const usePDFGenerator = (): usePDFGeneratorReturn => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateAndDownloadPDF = async (pdfComponent: React.ReactElement, fileName: string) => {
    setIsGenerating(true);
    
    try {
      // Generar el PDF
      const blob = await pdf(pdfComponent).toBlob();
      
      // Crear un enlace de descarga
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}.pdf`;
      
      // Simular clic para descargar
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Limpiar la URL del objeto
      URL.revokeObjectURL(url);
      
      toast.success('PDF generado y descargado exitosamente');
    } catch (error) {
      console.error('Error al generar PDF:', error);
      toast.error('Error al generar el PDF');
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    isGenerating,
    generateAndDownloadPDF,
  };
}; 